import ColoredLine from 'components/ColoredLine/ColoredLine';
import { Container } from 'react-bootstrap';
import './HighlightSection.scss';

const HighlightSection = ({
  children,
  coloredLineClassName = 'd-xl-none colored-line-form-wrapper',
}: {
  children: React.ReactNode;
  coloredLineClassName?: string;
}) => {
  return (
    <div className="bg-light-purple inverted-border-radius">
      <Container className="justify-content-center small">
        <div className={`d-block ${coloredLineClassName}`}>
          <ColoredLine />
        </div>
        {children}
      </Container>
    </div>
  );
};

export default HighlightSection;
